import { EmployerUsersShell } from '@/modules/employerUsers/pages/components/EmployerUsersShell/EmployerUsersShell'

export function Component() {
  return <EmployerUsersShell />
}

Component.displayName = 'EmployerUsers'
